import { render, staticRenderFns } from "./FinalFatworasPrint.vue?vue&type=template&id=b242287a&"
import script from "./FinalFatworasPrint.vue?vue&type=script&lang=js&"
export * from "./FinalFatworasPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports